import Constants from "../../../utils/Constants";

/**
 * Deterime if a node can be be dragger to a new location within the Inventory structure
 * 
 * @param {
*   node: object,
*   prevPath: number[] or string[], 
*   prevParent: object, 
*   prevTreeIndex: number, 
*   nextPath: number[] or string[], 
*   nextParent: object, 
*   nextTreeIndex: number }
* } moveInfo 
*/
export const determineIfNodeCanBeDragged = (moveInfo, debug = false) => {

  // Prevent the ain Inventory node from being drag.
  if (moveInfo.node.type === Constants.InventoryType.Inventory) {
    return false;
  }

  return true;
}

/**
 * Deterime if a node can be dropped into a new location within the Inventory structure
 * 
 * @param {
 *   node: object,
 *   prevPath: number[] or string[], 
 *   prevParent: object, 
 *   prevTreeIndex: number, 
 *   nextPath: number[] or string[], 
 *   nextParent: object, 
 *   nextTreeIndex: number }
 * } moveInfo 
 */
export const determineIfNodeCanBeDropped = (moveInfo, debug = false) => {

  debug && console.debug("Can Drop", {
    node: moveInfo.node,
    prevPath: moveInfo.prevPath,
    prevParent: moveInfo.prevParent,
    nextPath: moveInfo.nextPath,
    nextParent: moveInfo.nextParent
  });


  // If the new Parent node is missing, than make sure that the user cant 
  // drop the node.
  if (
    moveInfo.nextParent === null ||
    moveInfo.nextParent === undefined
  ) {
    debug && console.debug("[DISALLOWED] Parent is missing.")
    return false;
  }

  // If a Node is a Container and the Prev and New parent are the Inventory Node, its a Locker 
  // that is NOT a Heading (legacy setup). Allow it to be shifted.
  if (
    moveInfo.nextParent.type === Constants.InventoryType.Inventory &&
    moveInfo.prevParent.type === Constants.InventoryType.Inventory &&
    moveInfo.node.type === Constants.InventoryType.Container &&
    moveInfo.node.heading !== 1
  ) {
    debug && console.debug("[ALLOW] Legacy Locker Container (not a Container Heading) to be reordered directly under the Inventory node.");
    return true;
  };

  // If Node is a Standard Container and the new Parent is an Inventory node (its at locker level)
  // do not allow it to be dropped if it is NOT a heading Container
  if (
    moveInfo.nextParent.type === Constants.InventoryType.Inventory &&
    moveInfo.node.type === Constants.InventoryType.Container &&
    moveInfo.node.heading !== 1
  ) {
    debug && console.debug("[DISALLOW] Moving a node that is NOT Container Heading to be a Child of Inventory node.");
    return false;
  };

  // If Node is a Heading Container and the new Parent is an Inventory node (its at locker level)
  // do not allow it to be dropped if it heading Container that is not already at the Locker level
  if (
    moveInfo.nextParent.type === Constants.InventoryType.Inventory &&
    moveInfo.prevParent.type !== Constants.InventoryType.Inventory &&
    moveInfo.node.type === Constants.InventoryType.Container &&
    moveInfo.node.heading == 1
  ) {
    debug && console.debug("[DISALLOW] Moving a Heading Container from within Lockers to be a child of Inventory node.");
    return false;
  };

  // Prevent a Locker Container from being nested deeper than the Level 2
  if (
    moveInfo.nextParent.type !== Constants.InventoryType.Inventory &&
    moveInfo.prevParent.type === Constants.InventoryType.Inventory &&
    moveInfo.node.type === Constants.InventoryType.Container
  ) {
    debug && console.debug("[DISALLOW] Moving a Locker Container deeper than Level 2");
    return false;
  };

  // Prevent Item nodes from becoming parent nodes.
  if (
    moveInfo.nextParent.type === Constants.InventoryType.Item
  ) {
    debug && console.debug("[DISALLOW] Moving a Item or Container to be nested under a Item");
    return false;
  }
  
  // Prevent Item nodes from becoming direct children of Inventory nodes.
  if (
    moveInfo.nextParent.type === Constants.InventoryType.Inventory &&
    moveInfo.node.type === Constants.InventoryType.Item

  ) {
    debug && console.debug("[DISALLOW] Moving a Item to be a direct child of a Inventory node");
    return false;
  }

  debug && console.debug(
    `[ALLOW] Moving ${moveInfo.node.type} from Level ${moveInfo.prevPath.length} to Level ${moveInfo.nextPath.length}`
  );

  return true;
}